import { enums } from '@optimizely/optimizely-sdk';
const activeExperiments = [];

// These need to be hoisted up outside the component so that every server render doesn't create a new method and add it
// as a new listener.  By putting them at the top level optimizely will detect that it's the same function being added
// each time and skip a new registration.
const onActivate = activationEvent => {
  const {
    experiment = {},
    variation = {}
  } = activationEvent;
  if (experiment.key && variation.key) {
    if (!activeExperiments.includes(experiment.key + ':' + variation.key)) {
      activeExperiments.push(experiment.key + ':' + variation.key);
    }
  }
};
const onDecision = decisionEvent => {
  const {
    type,
    decisionInfo = {}
  } = decisionEvent;
  if (type === 'ab-test') {
    const {
      experimentKey,
      variationKey
    } = decisionInfo;
    // HAVE to make sure that variation key is not null.  A/B tests in optimizely still create a decision
    // even if you aren't in a qualifying audience.  Feature tests don't do this though???
    if (experimentKey && variationKey) {
      if (!activeExperiments.includes(experimentKey + ':' + variationKey)) {
        activeExperiments.push(experimentKey + ':' + variationKey);
      }
    }
  }
};
const OptimizelyTestDecisionListener = optimizely => {
  if (optimizely) {
    optimizely.notificationCenter.addNotificationListener(enums.NOTIFICATION_TYPES.DECISION, onDecision);
    optimizely.notificationCenter.addNotificationListener(enums.NOTIFICATION_TYPES.ACTIVATE, onActivate);
  }
};
const getActiveExperiments = () => activeExperiments;
export { getActiveExperiments };
export default OptimizelyTestDecisionListener;